import React, { useState } from 'react';
import styled from 'styled-components';

import BalanceStatsPanelWithData from '#/components/balances/BalanceStatsPanelWithData';
import DepositWithdrawalButtons from '#/components/balances/DepositWithdrawalButtons';
import ExpandableArrow from '#/components/basic/icons/ExpandableArrow';
import DashboardBottomTabs from '#/components/layout/dashboard/DashboardBottomTabs';
import OrderbookSection from '#/components/orders/orderBook/OrderbookSection';

import BuySellPanelWrap from './BuySellPanelWrap';
// import { BUYSELL_MOBILE_SCROLL_CLASS } from './layout';

const WrapGrid = styled.div`
  position: relative;
  flex: 1;

  display: grid;
  grid-template-columns: 1fr 1.27fr;
  grid-template-rows: 48px minmax(min-content, 60%) max-content;
  gap: 4px;
  padding: 0 4px;
  overflow: scroll;
`;

const ExpandableStats = styled.div<{ $expanded: boolean }>`
  grid-column-start: 1;
  grid-column-end: 3;

  width: 100%;
  z-index: 1234;
  position: absolute;
  ${({ $expanded }) => ($expanded ? 'background: var(--black1b);' : '')}
  height: ${({ $expanded }) => ($expanded ? 'initial' : '48px')};
  transition: background 0.5s ease-out;
  display: grid;
  gap: 8px;
  top: 0;
  padding: 14px 12px 13px 16px;
  grid-template-columns: 1fr max-content;

  background: var(--elevation-light);
  border-radius: 2px;

  box-shadow: ${({ $expanded }) =>
    $expanded ? '10px 10px 34px 4px var(--black)' : 'initial'};
`;

function BuySellPageMobile() {
  // const currentMarket = useSelector(state => state.markets.currentMarket);
  // const tickSize = useSelectMarketTickSize(currentMarket.pair);
  // const stepSize = useSelectMarketStepSize(currentMarket.pair);

  const [statsExpanded, setStatsExpanded] = useState(false);

  // // We need orderbook data for prices calculation (eg. "Match best ask" button)
  // useEffect(() => {
  //   if (!tickSize || !stepSize) {
  //     return;
  //   }
  //   if (currentMarket.pair) {
  //     const service = registerOrderBookService(
  //       currentMarket.pair,
  //       tickSize.asDecimal,
  //       tickSize.inPip,
  //       stepSize.visibleDecimals,
  //       () => {
  //         /* No action required */
  //       }
  //     );
  //     return service.unregister;
  //   }
  // }, [currentMarket.pair, tickSize, stepSize]);

  return (
    <WrapGrid>
      <div style={{ gridColumnStart: 1, gridColumnEnd: 3 }}>
        <ExpandableStats $expanded={statsExpanded}>
          <div>
            <BalanceStatsPanelWithData onlyCollateral={!statsExpanded} />
          </div>
          <ExpandableArrow
            onChange={setStatsExpanded}
            expanded={statsExpanded}
          />
          <div style={{ gridColumnStart: 1, gridColumnEnd: 3 }}>
            {statsExpanded && <DepositWithdrawalButtons />}
          </div>
        </ExpandableStats>
      </div>
      <OrderbookSection />
      <BuySellPanelWrap />
      <div style={{ gridColumnStart: 1, gridColumnEnd: 3 }}>
        <DashboardBottomTabs isMobileTradeScreen />
      </div>
    </WrapGrid>
  );
}

export default BuySellPageMobile;
